import React, { Component } from "react";
import data from "currency-codes/data";

import { Formik, Form } from "formik";
import { IconTextInput, CheckboxInput } from "../../../../forms/components";

import { editRates } from "../../../../libs/functions";

import Swal from "sweetalert2";
import Util from "../../../../libs/util";

class ManageEditMerchantRates extends Component {
	constructor(props) {
		super(props);

		this.state = {
			paymentTypes: Object.keys(props.MDRTypes),
			initialValues: this.getInitialValues(),
		};

		this.editRatesModalRef = React.createRef();
	}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps.rates) !== JSON.stringify(this.props.rates)) {
			this.setState({
				initialValues: this.getInitialValues(),
			});
		}
	}

	getGatewayName = (gateway) => {
		if (gateway === "tctp") return "2C2P";
		if (gateway === "uqpay") return "UQPay";
		if (gateway === "stripe") return "Stripe";
		if (gateway === "ipay88") return "iPay88";
		if (gateway === "rms") return "RMS";
		if (gateway === "ghlth") return "GHLTH";
		if (gateway === "netzme") return "Netzme";
	};

	getInitialValues = () => {
		const { rates, baseRate } = this.props;
		let mdrs = {};
		let mdrs_enable = {};
		for (let [key, value] of Object.entries(baseRate)) {
			if (rates[key]) {
				mdrs[key] = rates[key];
				mdrs_enable[key] = true;
			} else {
				mdrs[key] = {
					local: value.local.percent,
					overseas: value.overseas.percent,
				};
				mdrs_enable[key] = false;
			}
		}
		return { rates: mdrs, enable: mdrs_enable };
	};

	closeModal = () => {
		return Util.hideModal(`manage-edit-rates-${this.props.gateway}`).then(
			() => {
				this.editRatesModalRef.current.remove();
			}
		);
	};

	editRates = (values, { resetForm }) => {
		Swal.fire({
			title: "Editing rates",
			onBeforeOpen: () => {
				this.closeModal().then(() => {
					resetForm();
				});
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					const { merchant, gateway, currency } = this.props;
					let status = await editRates({
						merchant: merchant.id,
						gateway,
						currency,
						...values,
					});
					if (status) {
						Swal.fire({
							icon: "success",
							title: "Rates Edited",
						}).then(async () => {
							this.props.retrieveMerchants(true);
						});
					}
				} catch (err) {
					Swal.fire({
						icon: "error",
						title: `Unable to edit rates`,
						onClose: () => {},
					});
				}
			},
		});
	};

	render() {
		const { MDRTypes, gateway, currency, baseRate } = this.props;
		const { initialValues, paymentTypes } = this.state;
		let code = data.find((i) => i.number === String(currency)).code;

		return (
			<div
				id={`manage-edit-rates-${gateway}`}
				className="uk-modal-container"
				uk-modal="stack: true"
				ref={this.editRatesModalRef}
			>
				<div className="uk-modal-dialog uk-modal-body">
					<h2 className="uk-modal-title">
						Edit Transaction Fees, {this.getGatewayName(gateway)}, {code}
					</h2>
					<Formik
						initialValues={initialValues}
						enableReinitialize={true}
						onSubmit={this.editRates}
					>
						{(props) => {
							return (
								<Form onSubmit={props.handleSubmit}>
									<div className="edit-merchant-rates-table uk-overflow-auto uk-margin-bottom">
										<table className="uk-table uk-table-striped uk-table-middle">
											<thead>
												<tr>
													<th>Payment Type</th>
													<th>Local Card</th>
													<th>Overseas Card</th>
													<th className="uk-width-1-6">Enabled</th>
												</tr>
											</thead>
											<tbody>
												{paymentTypes.map((type) => {
													let paymentBaseRate = baseRate[type];
													let enable = !props.values.enable[type];

													if (paymentBaseRate)
														return (
															<tr key={`${type}-rate`}>
																<td>
																	<img
																		className="uk-img"
																		src={`data:image/*;base64,${MDRTypes[type].image}`}
																		width="35"
																	/>
																	<span className="uk-margin-small-left">
																		{MDRTypes[type].label}
																	</span>
																</td>
																<td>
																	<IconTextInput
																		id={`rates.${type}.local`}
																		name={`rates.${type}.local`}
																		icon="fa-solid-percent; ratio: 0.5"
																		iconFlip={true}
																		type="number"
																		step=".01"
																		min={paymentBaseRate.local.percent}
																		placeholder="Local"
																		disabled={enable}
																	/>
																</td>
																<td>
																	<IconTextInput
																		id={`rates.${type}.overseas`}
																		name={`rates.${type}.overseas`}
																		icon="fa-solid-percent; ratio: 0.5"
																		iconFlip={true}
																		type="number"
																		step=".01"
																		min={paymentBaseRate.overseas.percent}
																		placeholder="Overseas"
																		disabled={enable}
																	/>
																</td>
																<td className="uk-width-1-6 uk-text-center">
																	<CheckboxInput
																		id={`enable.${type}`}
																		name={`enable.${type}`}
																	/>
																</td>
															</tr>
														);
												})}
											</tbody>
										</table>
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Edit
										</button>
									</p>
								</Form>
							);
						}}
					</Formik>
				</div>
			</div>
		);
	}
}

export default ManageEditMerchantRates;
